// SubscriptionScreen.jsx
import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Divider,
  RadioGroup,
  FormControlLabel,
  Radio,
  IconButton,
  Skeleton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import axios from "../../axios-order";
import { toast } from "react-toastify";
// import CWS from "../../../../asserts/images/cws_final_logo.png";
import { useHistory } from "react-router-dom";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import CWS from "../../asserts/images/cws_final_logo.png";
import SMEIcon from "../../asserts/images/SME.png";
import CAIcon from "../../asserts/images/Multi-client firm.png";

const SubscriptionScreen = () => {
  // track whether the initial fetch has completed
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [plans, setPlans] = useState(null);
  const [payLoading, setPayLoading] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [pendingBusinessType, setPendingBusinessType] = useState(null);
  const [radioKey, setRadioKey] = useState(0);
  const [orderItems, setOrderItems] = useState([]);

  const handleBack = () => {
    history.goBack();
  };

  const postPaymentHandler = () => {
    toast.success("Subscription successful!", {
      autoClose: 1000,
      position: "top-center",
    });
    history.replace("/landingcws");
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const handleSubscribe = async (event) => {
    event.preventDefault();
    try {
      setPayLoading(true);

      const res = await axios.post("/create_order", {
        business_entity_id: localStorage.getItem("business_entity_id"),
        quantity: 1,
        entity_type: `${plans.name} subscription`,
        total: plans.total,
        gst_charges: plans.gst_charges,
      });

      const orderId = res.data.id;
      if (!orderId) throw new Error("Order ID not generated");

      const options = {
        key: process.env.REACT_APP_RAZORPAY_ID,
        name: "Cappitall Want Network",
        description: `${plans.name} subscription`,
        image: CWS,
        order_id: orderId,
        handler: postPaymentHandler,
        prefill: {
          name: localStorage.getItem("entity_name"),
          email: localStorage.getItem("EmailId"),
          contact: localStorage.getItem("contact"),
        },
        theme: { color: "#3399cc" },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      console.error(error);
      toast.error("Failed to start subscription");
    } finally {
      setPayLoading(false);
    }
  };

  useEffect(() => {
    const getBusinessType = async () => {
      const id = localStorage.getItem("business_entity_id");
      if (!id) {
        setLoading(false);
        return;
      }
      try {
        const { data } = await axios(`/get_plans/${localStorage.getItem("business_entity_id")}`);
        if (data.status) {
          // setPlans(data.plans);
          console.log("Comes here" + JSON.stringify())
          const orderItems = [
            {
              plan_name: data.plans.name,
              plan_id: data.plans.plan_id,
              description: `${data.plans.name} subscription`,
              features: data.plans.mandatory_features,
              amount: {
                sub_total: data.plans.sub_total,
                GST_charges: data.plans.gst_charges,
                total: data.plans.total,
              },
              addOn: data.plans.optional_features,
              msa_url: data.plans.msa_url,
              fy: ""
            },
          ];
          localStorage.setItem("business_type", data.plans.name);
          localStorage.setItem("plan_data", JSON.stringify(data.plans));
          history.push("/orderSummary", orderItems);
        }
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch business type");
      } finally {
        setLoading(false);
      }

    };

    getBusinessType();
  }, []);

  const handleBusinessTypeChange = async (e) => {
    const value = e.target.value;
    setPendingBusinessType(value);
    setConfirmDialogOpen(true);
  };

  const handleConfirm = async () => {
    setConfirmDialogOpen(false);
    localStorage.setItem("business_type", pendingBusinessType);
    try {
      const checkRes = await axios(`/check_if_exists_in_portal/${localStorage.getItem("business_entity_id")}`);

      if (checkRes.data.exists) {
        toast.error(checkRes.data.message, { autoClose: 3000 });
        setPendingBusinessType(null);        // ← reset
        setRadioKey(prev => prev + 1);       // ← reset
        return;
      }

      const res = await axios.post("/add_business_type", {
        business_entity_id: localStorage.getItem("business_entity_id"),
        business_type: pendingBusinessType,
      });

      if (!res.data.status) {
        throw new Error("Something went wrong. Please try again.");
      }
      try {
        const { data } = await axios(`/get_plans/${localStorage.getItem("business_entity_id")}`);
        if (data.status) {
          console.log("Comes here" + JSON.stringify(data));
          const orderItems = [
            {
              plan_name: data.plans.name,
              plan_id: data.plans.plan_id,
              description: `${data.plans.name} subscription`,
              features: data.plans.mandatory_features,
              amount: {
                sub_total: data.plans.sub_total,
                GST_charges: data.plans.gst_charges,
                total: data.plans.total,
              },
              addOn: data.plans.optional_features,
              msa_url: data.plans.msa_url,
              fy: ""
            },
          ];
          localStorage.setItem("business_type", data.plans.name);
          localStorage.setItem("plan_data", JSON.stringify(data.plans));
          history.push("/orderSummary", orderItems);
        }
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch business type");
        setPendingBusinessType(null);        // ← reset
        setRadioKey(prev => prev + 1);       // ← reset
      } finally {
        setLoading(false);
      }
    } catch (err) {
      toast.error(err.message || "Error updating business type", { autoClose: 3000 });
      setPendingBusinessType(null);          // ← reset
      setRadioKey(prev => prev + 1);         // ← reset
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setConfirmDialogOpen(false);
    setPendingBusinessType(null);
    setRadioKey(prev => prev + 1);
  };

  if (loading) {
    return (
      <Box sx={{ minHeight: "100vh", p: 4 }}>
        <Box sx={{ textAlign: "center", mt: 10 }}>
          <Skeleton
            variant="text"
            sx={{ padding: "2rem", margin: "0 30rem" }}
          />
        </Box>
        <Skeleton
          variant="rectangular"
          height={500}
          sx={{ mt: 10, mx: "30rem" }}
        />
      </Box>
    );
  }

  return (
    <>
      <Box
        sx={{
          height: "100vh",
          overflow: "hidden",
          minHeight: "100vh",
          p: 4,
          bgcolor: "#f5f7fb",
          position: "relative",
        }}
      >
        {/* Back Button */}
        <Box sx={{ position: "absolute", top: "6.5rem", left: 20 }}>
          <IconButton onClick={handleBack}>
            <ArrowBackIcon />
          </IconButton>
        </Box>

        {/* QUESTION SECTION */}
        {plans ? (
          <Box sx={{ textAlign: "center", mt: 10 }}>
            <Typography variant="h5" gutterBottom>
              Your Plan Details
            </Typography>
          </Box>
        ) : (
          <Box sx={{ textAlign: "center", mt: 0, display: "flex", flexDirection: "column", justifyContent: "center", height: "75vh" }}>
            {/* Step indicator */}
            {/* <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 4, gap: 1.5 }}>
              <Box sx={{
                width: 12, height: 12, borderRadius: "50%",
                bgcolor: "#1a3c5e"
              }} />
              <Typography sx={{ fontSize: 15, color: "#1a3c5e", fontWeight: 600 }}>
                Step 1 of 3
              </Typography>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Box sx={{ width: 80, height: 4, borderRadius: 2, bgcolor: "#1a3c5e" }} />
                <Box sx={{ width: 80, height: 4, borderRadius: 2, bgcolor: "#d0dce8" }} />
                <Box sx={{ width: 80, height: 4, borderRadius: 2, bgcolor: "#d0dce8" }} />
              </Box>
            </Box> */}

            <Typography variant="h4" fontWeight={700} color="#1a3c5e" gutterBottom sx={{ mb: 4 }}>
              Please select the option that best describes<br />your practice
            </Typography>

            <RadioGroup
              key={radioKey}
              row
              onChange={handleBusinessTypeChange}
              sx={{ justifyContent: "center", mt: 3, gap: 5, alignItems: "stretch" }}
            >
              {[
                {
                  value: "Multi Client Firm",
                  label: "I manage multiple clients",
                  subtitle: "Chartered Accountants, Accounting & Bookkeeping Services (ABS), and other firms managing multiple clients",
                  img: CAIcon,
                },
                {
                  value: "SME",
                  label: "I manage my own business",
                  subtitle: "Small and medium-sized enterprises and businesses",
                  img: SMEIcon,
                },
              ].map((option) => (
                <FormControlLabel
                  key={option.value}
                  value={option.value}
                  control={<Radio sx={{ display: "none" }} />}
                  label={
                    <Box
                      sx={{
                        width: 260,
                        height: "100%",
                        border: "2px solid",
                        borderColor: pendingBusinessType === option.value ? "#1a3c5e" : "#d0dce8",
                        borderRadius: 3,
                        p: 3,
                        cursor: "pointer",
                        position: "relative",
                        bgcolor: "#fff",
                        boxShadow: pendingBusinessType === option.value
                          ? "0 4px 20px rgba(26,60,94,0.18)"
                          : "0 2px 8px rgba(0,0,0,0.06)",
                        transition: "all 0.2s",
                        "&:hover": {
                          borderColor: "#1a3c5e",
                          boxShadow: "0 4px 20px rgba(26,60,94,0.15)",
                        },
                      }}
                    >
                      {/* Illustration */}
                      <Box sx={{
                        width: 150, height: 150, borderRadius: "50%",
                        bgcolor: "#eaf2fb",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        mx: "auto", mb: 2,
                        overflow: "hidden"
                      }}>
                        <img src={option.img} alt={option.label} style={{ width: 140, height: 140, objectFit: "contain" }} />
                      </Box>

                      <Typography fontWeight={700} fontSize={20} color="#1a3c5e" gutterBottom>
                        {option.label}
                      </Typography>
                      <Typography fontSize={14} color="#666" sx={{ whiteSpace: "pre-line", mb: 2 }}>
                        {option.subtitle}
                      </Typography>
                    </Box>
                  }
                  sx={{ mx: 0, alignItems: "stretch" }}
                />
              ))}
            </RadioGroup>

            {/* Wave decoration at bottom */}
            <Box sx={{
              position: "fixed", bottom: 0, left: 0, right: 0,
              pointerEvents: "none", zIndex: 0,
              lineHeight: 0,
            }}>
              <svg
                viewBox="0 0 1440 160"
                xmlns="http://www.w3.org/2000/svg"
                style={{ display: "block", width: "100%" }}
                preserveAspectRatio="none"
              >
                <path
                  d="M0,80 C180,160 360,0 540,80 C720,160 900,20 1080,80 C1260,140 1350,60 1440,80 L1440,160 L0,160 Z"
                  fill="#1a3c5e"
                  opacity="0.85"
                />
                <path
                  d="M0,110 C200,60 400,150 600,100 C800,50 1000,140 1200,100 C1300,80 1370,110 1440,100 L1440,160 L0,160 Z"
                  fill="#1a3c5e"
                  opacity="0.5"
                />
              </svg>
            </Box>
          </Box>
        )}
        {/* PLAN SECTION */}
        {plans && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 4,
              px: 2,
            }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: 750,
                bgcolor: "#fff",
                p: 6,
                borderRadius: 3,
                boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              }}
            >
              <Typography variant="h4" fontWeight={600} gutterBottom>
                {plans.name} Plan
              </Typography>

              <Divider sx={{ my: 3 }} />

              {Object.entries(JSON.parse(plans.features)).map(
                ([key, value], idx) => (
                  <Box
                    key={idx}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 2,
                    }}
                  >
                    <Typography variant="body1" color="text.secondary">
                      {key}
                    </Typography>
                    <Typography variant="body1" fontWeight={600}>
                      ₹{value}
                    </Typography>
                  </Box>
                ),
              )}

              <Divider sx={{ my: 3 }} />

              {/* Total */}
              <Box
                sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}
              >
                <Typography variant="h6" fontWeight={600}>
                  Total
                </Typography>
                <Typography variant="h6" fontWeight={600}>
                  ₹{plans.sub_total}
                </Typography>
              </Box>

              {/* GST */}
              <Box
                sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}
              >
                <Typography variant="body1" color="text.secondary">
                  18% GST
                </Typography>
                <Typography variant="body1" fontWeight={600}>
                  ₹{plans.gst_charges}
                </Typography>
              </Box>

              <Divider sx={{ my: 2 }} />

              {/* Grand Total */}
              <Box
                sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
              >
                <Typography variant="h5" fontWeight={700}>
                  Grand Total
                </Typography>
                <Typography variant="h5" fontWeight={700}>
                  ₹{plans.total}
                </Typography>
              </Box>
            </Box>
          </Box>
        )}
        {/* Subscribe Button */}
        {plans && (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
            <Button
              variant="contained"
              color="success"
              sx={{ px: 6, py: 2, borderRadius: 3 }}
              onClick={handleSubscribe}
              disabled={payLoading}
            >
              Subscribe Now
            </Button>
          </Box>
        )}
      </Box>
      <Dialog
        open={confirmDialogOpen}
        onClose={handleCancel}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "12px",
            padding: "8px",
            minWidth: "420px",
            fontFamily: "Dosis, sans-serif",
          }
        }}
      >
        <DialogTitle sx={{
          fontFamily: "Dosis, sans-serif",
          fontSize: "28px",
          fontWeight: "700",
          color: "#1a3c5e",
          borderBottom: "2px solid #e0e0e0",
          paddingBottom: "12px",
          letterSpacing: "0.5px"
        }}>
          Confirm Selection
        </DialogTitle>

        <DialogContent sx={{ paddingTop: "20px !important" }}>
          <DialogContentText sx={{
            fontFamily: "Dosis, sans-serif",
            fontSize: "20px",
            color: "#444",
            lineHeight: "1.8"
          }}>
            You have selected{" "}
            <strong style={{ color: "#1a3c5e", fontSize: "17px" }}>
              {pendingBusinessType}
            </strong>
            . Please note that once confirmed, this option{" "}
            <strong style={{ color: "#d32f2f" }}>cannot be changed</strong>
            . Do you wish to proceed?
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ padding: "16px 24px", gap: "10px" }}>
          <Button
            onClick={handleCancel}
            variant="outlined"
            sx={{
              fontFamily: "Dosis, sans-serif",
              fontWeight: "600",
              fontSize: "15px",
              borderRadius: "8px",
              borderColor: "#d32f2f",
              color: "#d32f2f",
              px: 3,
              "&:hover": { backgroundColor: "#fdecea", borderColor: "#d32f2f" }
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            variant="contained"
            sx={{
              fontFamily: "Dosis, sans-serif",
              fontWeight: "600",
              fontSize: "15px",
              borderRadius: "8px",
              backgroundColor: "#1a3c5e",
              px: 3,
              "&:hover": { backgroundColor: "#153250" }
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SubscriptionScreen;